var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAboutQuestionMarkGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6253 14.2822C10.6253 14.3643 10.6919 14.4309 10.774 14.4309H12.5433C12.6254 14.4309 12.692 14.3643 12.692 14.2822C12.7044 13.0696 13.1327 12.5148 14.1443 11.9428C15.2863 11.3136 16 10.4557 16 9.14585C16 7.21258 14.3677 6 11.9969 6C10.0025 6 8.3534 6.93539 8.04872 8.77074C8.00259 9.04867 8.23275 9.28313 8.51448 9.28313H9.73476C10.0008 9.28313 10.2111 9.07042 10.2915 8.81679C10.5318 8.0585 11.2471 7.69304 11.9845 7.69304C12.9341 7.69304 13.6974 8.27645 13.6974 9.17445C13.6974 9.97521 13.1202 10.5243 12.3693 10.959C11.2708 11.5882 10.6377 12.2231 10.6253 14.2822ZM11.7114 18C12.4438 18 13.0706 17.4395 13.0768 16.7417C13.0706 16.0553 12.4438 15.4948 11.7114 15.4948C10.9542 15.4948 10.3398 16.0553 10.346 16.7417C10.3398 17.4395 10.9542 18 11.7114 18Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAboutQuestionMarkGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/about_question_mark_gray.335952fc31979a8c5b30d67b606487c9.svg";